import './App.css';
import { ChakraProvider } from '@chakra-ui/react';
import theme from "./theme/theme";
import Layout from './Layout';
import { useEffect, useRef, useState } from 'react';
import { PortfolioDataProvider } from './PortfolioDataProvider';

function App() {
  const scrollContainerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startY, setStartY] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const container = scrollContainerRef.current;

    if (!container) return;

    const handleMouseDown = (event) => {
      setIsDragging(true);
      setStartY(event.pageY - container.offsetTop);
      setScrollTop(container.scrollTop);
    };

    const handleMouseMove = (event) => {
      if (!isDragging) return;
      const y = event.pageY - container.offsetTop;
      const scroll = y - startY;
      container.scrollTop = scrollTop - scroll;
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    const handleTouchStart = (event) => {
      setIsDragging(true);
      setStartY(event.touches[0].pageY - container.offsetTop);
      setScrollTop(container.scrollTop);
    };

    const handleTouchMove = (event) => {
      if (!isDragging) return;
      const y = event.touches[0].pageY - container.offsetTop;
      const scroll = y - startY;
      container.scrollTop = scrollTop - scroll;
    };

    container.addEventListener('mousedown', handleMouseDown);
    container.addEventListener('mousemove', handleMouseMove);
    container.addEventListener('mouseup', handleMouseUp);
    container.addEventListener('mouseleave', handleMouseUp); // handle mouse leaving the container
    container.addEventListener('touchstart', handleTouchStart);
    container.addEventListener('touchmove', handleTouchMove);
    container.addEventListener('touchend', handleMouseUp);

    return () => {
      container.removeEventListener('mousedown', handleMouseDown);
      container.removeEventListener('mousemove', handleMouseMove);
      container.removeEventListener('mouseup', handleMouseUp);
      container.removeEventListener('mouseleave', handleMouseUp);
      container.removeEventListener('touchstart', handleTouchStart);
      container.removeEventListener('touchmove', handleTouchMove);
      container.removeEventListener('touchend', handleMouseUp);
    };
  }, [isDragging, startY, scrollTop]);

  useEffect(() => {
    // Disable right-click context menu
    const handleContextMenu = (event) => {
      event.preventDefault();
    };
    document.addEventListener('contextmenu', handleContextMenu);

    // Disable copy shortcut keys
    const handleKeydown = (event) => {
      if ((event.ctrlKey && (event.key === 'c' || event.key === 'a')) ||
          (event.metaKey && (event.key === 'c' || event.key === 'a'))) {
        event.preventDefault();
      }
    };
    document.addEventListener('keydown', handleKeydown);

    // Cleanup event listeners on component unmount
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeydown);
    };
  }, []);

  return (
    <PortfolioDataProvider>
      <ChakraProvider theme={theme}>
        <div ref={scrollContainerRef} style={{ height: '100vh', overflow: 'auto' }}>
          <Layout />
        </div>
      </ChakraProvider>
    </PortfolioDataProvider>
  );
}

export default App;
